import { createSlice } from "@reduxjs/toolkit"

export const CartSlice = createSlice({
        name: "cart",
        initialState: [],
        reducers: {
            addToCart: (state,action) => {
                state.push(action.payload);
            },
            removeFromCart: (state,action) => { 
                return state.filter((product) => product.id !== action.payload);
            }
        }
})

export const {addToCart, removeFromCart} = CartSlice.actions;
export default CartSlice.reducer;